import React from "react";
import ModelingImg from "../assets/img/images/maya1.jpg";
import AnimationImg from "../assets/img/images/maya2.jpg";
import RenderingImg from "../assets/img/images/maya3.jpg";

const Autodeskmaya = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Autodesk Maya</h1>
      <p style={styles.description}>
        Autodesk Maya is a professional 3D computer graphics software used for creating interactive 3D animations, models, and simulations.
        It's a widely used software in the entertainment, architecture, and product design industries.
        Maya allows users to model 3D objects and scenes, animate characters, create realistic effects like explosions and cloth simulations, and render final images.
      </p>

      <div style={styles.flexRow}>
        <img src={ModelingImg} alt="Modeling in Maya" style={styles.image} />
        <img src={AnimationImg} alt="Animation in Maya" style={styles.image} />
      </div>

      <div style={styles.cardContainer}>
        <div style={{ ...styles.card, backgroundColor: "#79a6d2" }}>
          <h3 style={styles.subTitle}>Key Features and Uses</h3>
          <ul style={styles.cardList}>
            <li><strong>Modeling:</strong> Creating 3D shapes and models using various tools and techniques.</li>
            <li><strong>Animation:</strong> Bringing models to life with various animation tools and techniques.</li>
            <li><strong>Visual Effects:</strong> Creating special effects for films, TV, and video games.</li>
            <li><strong>Simulation:</strong> Simulating physics-based effects like fluids, cloth, and explosions.</li>
            <li><strong>Rendering:</strong> Producing final images and videos from the 3D scene.</li>
          </ul>
        </div>

        <div style={{ ...styles.card, backgroundColor: "#79a6d2" }}>
          <h3 style={styles.subTitle}>Industries and Applications</h3>
          <ul style={styles.cardList}>
            <li><strong>Film and TV:</strong> Creating animated films, TV series, and visual effects.</li>
            <li><strong>Video Games:</strong> Developing interactive 3D assets for video games.</li>
            <li><strong>Architecture:</strong> Creating architectural visualizations and models.</li>
            <li><strong>Product Design:</strong> Designing and visualizing product designs.</li>
          </ul>
        </div>
      </div>

      <div style={styles.bottomSection}>
        <div style={styles.textContent}>
          <div style={styles.whiteCard}>
            <h3 style={styles.subTitle}>Key Considerations</h3>
            <ul style={styles.considerations}>
              <li><strong>Learning Curve:</strong> Maya has a steep learning curve and requires dedicated study to become proficient.</li>
              <li><strong>Software Versions:</strong> Autodesk regularly updates Maya with new features and improvements.</li>
              <li><strong>Pricing and Availability:</strong> Maya is a professional-grade software and is available through subscription or purchase.</li>
            </ul>
          </div>

          <div style={{ marginTop: "30px" }}>
            <h3 style={styles.subTitle}>Learn More</h3>
            <p>Explore more about Autodesk Maya and how it can benefit your creative projects:</p>
            <ul>
              <li>
                <a href="https://www.autodesk.com/products/maya/overview" target="_blank" rel="noopener noreferrer" style={styles.link}>
                  Autodesk Maya Official Website
                </a>
              </li>
              <li>
                <a href="https://www.lynda.com/Maya-training-tutorials/252-0.html" target="_blank" rel="noopener noreferrer" style={styles.link}>
                  Lynda Maya Tutorials
                </a>
              </li>
            </ul>
          </div>
        </div>

        <img src={RenderingImg} alt="Rendering in Maya" style={styles.sideImage} />
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#f9fafb",
    marginTop: "6rem",
    fontFamily: "'Poppins', sans-serif",
  },
  title: {
    color: "#7620ff",
    textAlign: "center",
    marginBottom: "1rem",
  },
  description: {
    textAlign: "left",
    margin: "0 auto",
    lineHeight: "1.6",
    maxWidth:"80%",
  },
  flexRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "20px",
    marginTop: "30px",
  },
  image: {
    width: "100%",
    maxWidth: "600px",
    height: "300px",
    objectFit: "cover",
    borderRadius: "10px",
    flex: "1 1 300px",
  },
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "20px",
    marginTop: "30px",
  },
  card: {
    padding: "20px",
    borderRadius: "10px",
    color: "#fff",
    maxWidth: "600px",
    width: "100%",
    boxSizing: "border-box",
    lineHeight: "1.6",
  },
  cardList: {
    paddingLeft: "10px",
    lineHeight: "1.6",
  },
  bottomSection: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
    marginTop: "40px",
  },
  textContent: {
    flex: "1 1 400px",
    maxWidth: "800px",
  },
  whiteCard: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
    marginBottom: "2rem",
  },
  subTitle: {
    color: "#fdba00",
    marginBottom: "1rem",
  },
  considerations: {
    paddingLeft: "20px",
    color: "#333",
    lineHeight: "1.6",
    marginBottom: "1rem",
  },
  sideImage: {
    flex: "1 1 300px",
    maxWidth: "400px",
    height: "200px",
    objectFit: "cover",
    borderRadius: "10px",
  },
  link: {
    color: "#2196F3",
    textDecoration: "underline",
    lineHeight: "1.6",
  },
};

export default Autodeskmaya;
